export default function FormPartMixin() {
    return {
        props: {
            index: Number,
            order: Object,
            errors: Object,
            loading: Boolean,
            product: Object,
        },
        data() {
            return {
                status: 'invalid',
            };
        },
        created() {
            // Register itself to the instance Array
            // this.insertPartInstance();
        },
        destroyed() {
            // Remove itself from the instance Array
            // this.removePartInstance();
        },
        mounted() {
            // this.focusActivePartInstance();
        },
        methods: {
            showErrors() {
                Object.entries(this.$refs)
                    .forEach(([, element]) => {
                        element.$refs.input.dispatchEvent(new Event('blur'));
                    });
            },
            hideErrors() {
                Object.entries(this.$refs)
                    .forEach(([, element]) => {
                        element.$refs.input.dispatchEvent(new Event('input'));
                    });
            },
            validate() {
                // console.log(`${this.$options.name} has no validation func implemented yet`);
                this.status = 'complete';
            },

        },
        computed: {
        },
        watch: {
            order: {
                handler() {
                    if (this.status === 'active') {
                        this.$emit('update:order', this.order);
                    }
                },
                deep: true,
            },
        },
    };
}
